import React from 'react'
import { VideoRender } from '../../pages/Lpp/lpp-view';
import { OfficeRender } from './OfficeRender';
import { PdfRender } from './PdfRender';
import { getStepRenderType } from './RenderHelper';
import { TextRender } from './TextRender';
import { VideoRenderDash } from '../../pages/Lpp/lpp-view/video-renderDash';

export const Render = ({ step, standardType, ...props }) => {
    // console.log(getStepRenderType(step))
    //console.log(getStepRenderType(step))

    switch ( getStepRenderType(step) ) {
        case 99:
            if(step.content.includes('job-'))
                return (<>Video em processamento. Salve e retorne em 5-10 minutos (atualize a página) para ver o vídeo.</>)
            if (step.content == '[]')
                return (<>Falha no upload de vídeo, tente novamente.</>)
            return (<></>)
        case 7:
        case 8:
        case 9:
        case 10:
            return (<OfficeRender step={step} {...props} />)
        case 4:
            return (<PdfRender step={step} {...props} />)
        case 1:
            return (<VideoRender step={step} {...props} />)
        case 2:
            return (<TextRender step={step} standardType={standardType} {...props} />)
        case 100:
            return (<VideoRenderDash step={step} {...props} />)
        default:
            if (getStepRenderType(step).startsWith("ism/manifest"))
                return (<VideoRender step={step} {...props} />)
            else
                return (<>Formato não suportado</>)
    }
} 